/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useMemo, useEffect } from 'react';
import Pagination from '../../../widgets/pagination';
import { mediaPreparationService } from "../../../service/mediaPrepBatchServices";
import { getColumns } from './partials/column';
import MediaPreparationTable from '../../common/commonComponents/mediaPreparationTable';
import MediaPrepPageHeader from '../../common/commonComponents/mediaPrepPageHeader';
import MediaPrepHeaderSection from '../../common/commonComponents/mediaPrepheaderSection';
import { useTranslation } from 'react-i18next';
import FilterBar from "../media_preparation/media_powder_inventory/partials/filterBar";
import { userService as plateRelatedService } from '../../../service/plateServices';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import BatchStatusCard from './partials/mediaPrepStatusCard';
import BatchDetails from './views/mediaBatchDetails';
import MediaLotDetails from '../media_preparation/media_powder_inventory/views/mediaLotDetails';
import BatchLotUsageDetails from '../media_preparation/media_powder_inventory/views/batchLotUsageDetails';
import { useNavigate } from "react-router-dom";
import { userService } from '../../../service/userService';



const BatchManagement: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [batchCodeFilter, setBatchCodeFilter] = useState('');
  const [mediaTypeFilter, setMediaTypeFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState<"list" | "details" | "lotDetails" | "lotUsage">("list");
  const [selectedLotId, setSelectedLotId] = useState<string>("");
  const [selectedBatchId, setSelectedBatchId] = useState<string>("");
  const [selectedLotSummary, setSelectedLotSummary] = useState<any>(null);
  const [selectedUsageLotId, setSelectedUsageLotId] = useState("");
  const [loading, setLoading] = useState(false);

  const [batches, setBatches] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { t } = useTranslation();
  const [plateTypes, setPlateTypes] = useState([]);

  const [searchInput, setSearchInput] = useState('');
  const [batchCodes, setBatchCodes] = useState<string[]>([]);

  const [stats, setStats] = useState<any>({
    active_batches: {},
    in_sterilizer: {},
    success_rate: {},
    media_stock: {},
  });


  const [sort, setSort] = useState("id");
      const [order, setOrder] = useState("desc");
      const handleSort = (key: string, value: boolean) => {
        setSort(key);
        setOrder(value ? "asc" : "desc");
        setCurrentPage(1);
      };


  const [permission, setPermission] = useState<any>([]);
	const getPermissionByRole = async (role: number) => {
		try {
		const response = await userService.getPermissionByRole(role);

		if (response.status && response.statusCode === 200) {
			setPermission(response.data.permissions);
		}
		} catch (error) {
		console.error(error);
		}
	};

	useEffect(() => {
		const storedData = localStorage.getItem("userDetails");

		if (storedData) {
		const storedObject = JSON.parse(storedData);
		getPermissionByRole(storedObject[0].role_master_id);
		}
	}, []);

  const getMediaPreparationStats = async () => {
    try {
      const response =
        await mediaPreparationService.getMediaPreparationStats();

      if (response.status && response.statusCode === 200) {
        setStats(response.data);
      }
    } catch (error) {
      console.error("Stats API error:", error);
    }
  };  

  const getMediaPreparationBatchList = async () => {
    setLoading(true);
    try {
        const response =
        await mediaPreparationService.getMediaPreparationBatchList(
            currentPage,
            pageSize,
            sort,
            order,
            searchTerm,
            statusFilter,
            batchCodeFilter,
            mediaTypeFilter,
            fromDate,
            toDate
        );

        if (response.status && response.statusCode === 200) {
        const mappedData = response.data.map((item: any) => ({
            id: item.media_batch_identifier,
            mediaType: item.media_type,
            status: item.status,
            preparedBy: item.lead_technician_name,
            dateCreated: item.created_at,
            batchId: item.id,
        }));

        setBatches(mappedData);
        setTotalPages(response.totalPages);
        setTotalElements(response.totalElements);
        } else {
        setBatches([]);
        }
    } catch (error) {
        console.error("API error:", error);
    }
    finally {
      setLoading(false);
    }
  };


     // batch code list for filter dropdown 
    const getBatchCodes = async () => {
      try {
        const response = await mediaPreparationService.mediaPrepgetBatchCodes();
  
        if (response.status && response.statusCode === 200) {
          const codes = response.data.map((item: any) => item.media_batch_identifier);
          setBatchCodes(codes);
        }
      } catch (error) {
        console.error("Batch code API error:", error);
      }
    };

    //api call to get the plate types 
   const getPlateTypeList = async () => {
    try {
      const response = await plateRelatedService.listAllPlateTypes();

      if (response.status && response.statusCode === 200) {
        const formatted = response.data.map((item: any) => ({
          id: item.id,
          name: item.plate_type   
        }));

        setPlateTypes(formatted);
      }
    } catch (error) {
      console.error('user response', error);
    }
  };


  useEffect(() => {
  getMediaPreparationBatchList();
    }, [
    currentPage,
    pageSize,
    sort,
    order,
    searchTerm,
    statusFilter,
    batchCodeFilter,
    mediaTypeFilter,
    fromDate,
    toDate
    ]);

    useEffect(() => {
      getMediaPreparationStats();
    }, []);

    useEffect(() => {
    getBatchCodes();
    }, []);

    useEffect(() => {
    getPlateTypeList();
    }, []);

  const handleItemsPerPageChange = (items: number) => {
    setCurrentPage(1);
    };

  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page);

    if (size) {
        setPageSize(size);
    }
  };

  const handleClearFilters = () => {
    setSearchInput('');
    setSearchTerm('');
    setStatusFilter('');
    setBatchCodeFilter('');
    setMediaTypeFilter('');
    setFromDate('');
    setToDate('');
    setCurrentPage(1);
  };

  const handleEdit = (batchId: string) => {
    navigate(`/startMediaPreparation?batchId=${batchId}`);
  };


  if (view === "lotUsage" && selectedUsageLotId) {
    return (
      <BatchLotUsageDetails
        lotId={selectedUsageLotId}
        onBack={() => setView("lotDetails")}
      />
    );
  }
  
  if (view === "lotDetails" && selectedLotId) {
    return (
      <MediaLotDetails
        lotId={selectedLotId}
        selectedLotSummary={selectedLotSummary}
        onBack={() => {
          setView("details");
        }}
        onViewLotUsage={(lotId) => {
          setSelectedUsageLotId(lotId);
          setView("lotUsage");
        }}
      />
    );
  }

  if (view === "details" && selectedBatchId) {
    return (
      <BatchDetails
        batchId={selectedBatchId}
        onBack={() => {
          setView("list");
          getMediaPreparationBatchList();
          getMediaPreparationStats();
          getBatchCodes();
        }}
        onViewLotDetails={(lotId, lotSummary) => {
          setSelectedLotId(lotId);
          setSelectedLotSummary(lotSummary);
          setView("lotDetails");
        }}
      />
    );
  }

  return (
    <div className="media-prep-scope">
    <MediaPrepHeaderSection />
    <MediaPrepPageHeader pageHeader={t('mediaPrepBatch.title')} pageDescription={t('pageDescription.mediaBatchManagement.description')} />
    
    <div className="media-prep-scope px-8 pb-13 pt-3 max-w-full animate-in fade-in duration-500 min-h-full">
      <div className="flex items-start justify-between mb-2">
        <div>
          {/* <h2 className='headText1 m-0 d-flex align-items-center' style={{ fontSize: '18px', height: '100%' }}>{t('mediaPrepBatch.title')}</h2>
          <p className="text-slate-400 text-[12.5px] font-medium">{t('mediaPrepBatch.description')}</p> */}
        </div>
        <div className="ml-[385px] mt-1">
          {permission?.includes("add_new_media_batch") && (
          <button 
            onClick={() => navigate("/startMediaPreparation")}
            className="bg-[#FF7043] text-white flex items-center gap-1 px-4 py-2 rounded-lg shadow-[0_8px_20px_rgba(255,112,67,0.2)] font-semibold text-xs uppercase tracking-wide hover:brightness-110 active:scale-95 transition-all border-none"
          >
            <span className="material-symbols-outlined">{t('mediaPrepBatch.icons.add')}</span>
            {t('mediaPrepBatch.actions.addBatch')}
          </button>
          )}
        </div>  
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-3.5">
        {[
          { label: stats.active_batches?.label, val: stats.active_batches?.value, color: "#94A3B8", trend: stats.active_batches?.status },
          { label: stats.in_sterilizer?.label, val: stats.in_sterilizer?.value, color: "#F59E0B", trend: stats.in_sterilizer?.status },
          { label: stats.success_rate?.label, val: `${stats.success_rate?.value ?? 0}${stats.success_rate?.unit ?? ""}`, color: "#8B5CF6", trend: stats.success_rate?.status },
          { label: stats.media_stock?.label, val: `${stats.media_stock?.value ?? 0} ${stats.media_stock?.unit ?? ""}`, color: "#10B981", trend: stats.media_stock?.status },
        ].map((box, i) => (
          <BatchStatusCard
            key={i}
            label={box.label}
            value={box.val}
            color={box.color}
            trend={box.trend}
          />
        ))}
      </div>

      <FilterBar
        batchCodes={batchCodes}
        statuses={[
            t('mediaPrepBatch.status.Draft'),
            t('mediaPrepBatch.status.Fine Tuned'),
            t('mediaPrepBatch.status.In Preparation'),
            t('mediaPrepBatch.status.Sterilized'),
            t('mediaPrepBatch.status.Rejected'),
            t('mediaPrepBatch.status.Ready to Use'),
            t('mediaPrepBatch.status.Media Dispensed'),
        ]}
        mediaTypes={plateTypes}
        selectedBatchCode={batchCodeFilter}
        selectedStatus={statusFilter}
        selectedMediaType={mediaTypeFilter}
        fromDate={fromDate}
        toDate={toDate}
        searchTerm={searchInput}

        onBatchCodeChange={(val) => {
            setBatchCodeFilter(val);
            setCurrentPage(1);
        }}

        onStatusChange={(val) => {
            setStatusFilter(val);
            setCurrentPage(1);
        }}

        onMediaTypeChange={(val) => {
            setMediaTypeFilter(val);
            setCurrentPage(1);
        }}

        onFromDateChange={(val) => {
            setFromDate(val);
            setCurrentPage(1);
        }}

        onToDateChange={(val) => {
            setToDate(val);
            setCurrentPage(1);
        }}

        onSearchChange={(val) => {
          setSearchInput(val);

          if (!val) {
            setSearchTerm("");
            setCurrentPage(1);
          }
        }}

        onSearchClick={() => {
          setSearchTerm(searchInput);
          setCurrentPage(1);
        }}

        onClearFilters={handleClearFilters}
        />

      <MediaPreparationTable
        columns={getColumns(t)}
        data={batches}
        loading={loading}
        currentPage={currentPage}
        pageSize={pageSize}
        onSortClick={handleSort}
        renderAction={(row) => (
          <div className="flex gap-2">
            <button
              onClick={() => {
                setSelectedBatchId(row.batchId);
                setView("details");
              }}
              className="flex items-center justify-center gap-1 w-[75px] h-[26px] bg-[#EBEBF1] text-[#36405D] rounded-lg font-black text-[8px] uppercase tracking-widest border-none outline-none shadow-none focus:outline-none focus:ring-0"
            >
              <span className="material-symbols-outlined text-base text-[#36405D]">
                {t('mediaPrepBatch.icons.visibility')}
              </span>
              {t('mediaPrepBatch.actions.view')}
            </button>

            {permission?.includes("edit_new_media_batch") && (
            <button
              onClick={() => handleEdit(row.batchId)}
              disabled={
                row.status === "Ready to Use" ||
                row.status === "Rejected"
              }
              className={`flex items-center justify-center gap-1 w-[75px] h-[26px] rounded-lg font-black text-[8px] uppercase tracking-widest border-none outline-none focus:outline-none transition-all
                ${
                  row.status === "Ready to Use" || row.status === "Rejected"
                    ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                    : "bg-[rgb(54,64,93)] text-white hover:brightness-110 active:scale-95 shadow-sm"
                }`}
            >
              <span className="material-symbols-outlined text-[12px]">
                edit
              </span>
              Edit
            </button>
            )}
          </div>
        )}
        />
        <Pagination
        page={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default BatchManagement;
